import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TableColumnWidthInfo } from '@devexpress/dx-react-grid';

import { bundlesLoaded } from './bundlesSlice';
import { statusSet } from './productionComponentInstancesSlice';

interface LineScheduleGridState {
  readonly checkedRows: readonly string[];
  readonly expandedRows: readonly string[];
  readonly userColumnWidths: TableColumnWidthInfo[] | null;

  /**
   * Stored in the URL as well, having this in Redux allows this value to persist across tab changes.
   */
  readonly lineGuidFilter: string | null;
}

const initialState: LineScheduleGridState = {
  checkedRows: [],
  expandedRows: [],
  userColumnWidths: null,
  lineGuidFilter: null,
};

const lineScheduleGridSlice = createSlice({
  name: 'lineScheduleGrid',
  initialState,
  reducers: {
    expandRows: (state, action: PayloadAction<readonly string[]>) => {
      for (const rowId of action.payload) {
        if (state.expandedRows.includes(rowId)) continue;
        state.expandedRows.push(rowId);
      }
    },
    collapseRows: (state, action: PayloadAction<readonly string[]>) => {
      state.expandedRows = state.expandedRows.filter((expandedRow) => !action.payload.includes(expandedRow));
    },
    checkRows: (state, action: PayloadAction<readonly string[]>) => {
      for (const rowId of action.payload) {
        if (state.checkedRows.includes(rowId)) continue;
        state.checkedRows.push(rowId);
      }
    },
    uncheckRows: (state, action: PayloadAction<readonly string[]>) => {
      state.checkedRows = state.checkedRows.filter((checkedRow) => !action.payload.includes(checkedRow));
    },
    lineGuidFilterChanged: (state, action: PayloadAction<string>) => {
      state.checkedRows = [];
      state.expandedRows = [];
      state.lineGuidFilter = action.payload;
    },
    setUserColumnWidths: (state, action: PayloadAction<TableColumnWidthInfo[]>) => {
      state.userColumnWidths = action.payload;
    },
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(bundlesLoaded, (state) => {
      state.checkedRows = [];
    });
    builder.addCase(statusSet, (state) => {
      state.checkedRows = [];
    });
  },
});

export const { expandRows, collapseRows, checkRows, uncheckRows, lineGuidFilterChanged, setUserColumnWidths } =
  lineScheduleGridSlice.actions;
export const lineScheduleGrid = lineScheduleGridSlice.reducer;
